import React, { Component } from "react";

class MobileBottomBar extends Component {
    state = {}
    render() {
        let HighIndexedWindow = this.props.HighIndexedWindow
        // console.log(HighIndexedWindow)
        return (
            <div className="MobileBottomBar" style={{ width: window.innerWidth, height: 60, zIndex: 1000, position: 'absolute', bottom: 10, left: 0 }}>
                <div></div>
            </div>
        );
    }
}

export default MobileBottomBar;